import { actions } from "./Font.actions";

type Action = {
  type: keyof typeof actions;
  payload?: any;
};

const initialState = {
  fontSize: 16
};

export default function mathReducer(state = initialState, action: Action) {
  const { fontSize } = state;
  switch (action.type) {
    case actions.FONT_SIZE_INCREMENT:
      return { fontSize: fontSize < 22 ? fontSize + 2 : fontSize };
    case actions.FONT_SIZE_DECREMENT:
      return { fontSize: fontSize > 10 ? fontSize - 2 : fontSize };
    case actions.FONT_SIZE_RECOVERY:
      return initialState;
    default:
      return state;
  }
}
